import React, { ReactNode } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import AppHeader from "./AppHeader";
import { useLocation, Link } from "react-router-dom";
import "../styles/Globals.css";

interface LayoutProps {
  children: ReactNode;
  hideNavbar?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, hideNavbar = false }) => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const isHomePage = location.pathname === "/";
  const isVotePage = location.pathname === "/vote";
  const shouldShowHeader = !hideNavbar && !isHomePage;
  const shouldShowFooter =
    !hideNavbar && !isHomePage && !(isVotePage && isMobile);

  return (
    <div className="flex flex-col min-h-screen bg-[#f8f8f8] text-[#333333]">
      {shouldShowHeader && <AppHeader />}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          position: "relative",
        }}
      >
        {children}
      </Box>

      {shouldShowFooter && (
        <footer className="container mx-auto px-4 py-6 text-xs font-light text-[#333333]/50">
          <div className="flex flex-col justify-between space-y-4 md:flex-row md:space-y-0">
            <div>© 2025 ranked. All rights reserved.</div>
            <div className="space-x-6"></div>
          </div>
        </footer>
      )}
    </div>
  );
};

export default Layout;
